import updateUndoSendOption from '../data/mutators/updateUndoSendOption';
import { updateUserConfiguration } from 'owa-options-core';
import { getUserConfiguration } from 'owa-session-store';

export default async function saveUndoSendOption() {
    let userOptions = getUserConfiguration().UserOptions;
    updateUndoSendOption(userOptions);

    await updateUserConfiguration([
        {
            propertyName: 'MailSendUndoInterval',
            propertyType: 'Integer32',
            propertyValue: `${userOptions.MailSendUndoInterval}`,
        },
    ]);
}
